import { Navigate, useLocation } from "react-router";
import { useSelector } from "react-redux";
import useRole from "../hooks/useRole";
import usePermissions from "../hooks/usePermissions";
import { getOpsHomePath } from "../utils/opsHome";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

/**
 * Restrict route by ops role list. Prefer PermissionRoute for new gates.
 */
export function RoleRoute({ roles, children }) {
  const { can } = useRole();

  if (!can(roles)) {
    return <Navigate to="/dashboard/unauthorized" replace />;
  }

  return children;
}

/**
 * Restrict route by permission key(s). User needs any listed permission.
 */
export function PermissionRoute({ permission, permissions, children }) {
  const { hasAnyPermission } = usePermissions();
  const keys = permissions ?? (permission ? [permission] : []);

  if (keys.length && !hasAnyPermission(keys)) {
    return <Navigate to="/dashboard/unauthorized" replace />;
  }

  return children;
}

export function GuestRoute({ children }) {
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  if (isAuthenticated) {
    return <Navigate to={getOpsHomePath(user)} replace />;
  }

  return children;
}
